import ButtonOptions from "%/dynamic-component-editor/bundles/button-options";
import ButtonType from "%/dynamic-component-editor/options/button-type";
import ButtonSize from "%/dynamic-component-editor/options/button-size";
import Icon from "%/dynamic-component-editor/options/icon";
import IconPosition from "%/dynamic-component-editor/options/icon-position";
import ButtonIconSize from "%/dynamic-component-editor/options/button-icon-size";
import TextAlignment from "%/dynamic-component-editor/options/text-alignment";
import ButtonAction from "%/dynamic-component-editor/options/button-action";
import { DynamicElementMixin } from "%/dynamic-component-editor/mixins/dynamic-element-mixin";
import BasicTextOptions from "%/dynamic-component-editor/bundles/basic-text-options";
import AppearanceOptions from "%/dynamic-component-editor/bundles/appearance-options";
import PositioningOptions from "%/dynamic-component-editor/bundles/positioning-options";
import SpacingOptions from "%/dynamic-component-editor/bundles/spacing-options";
import LayoutWidthHeightOptions from "%/dynamic-component-editor/bundles/layout-width-height-options";
import BorderRadius from "%/dynamic-component-editor/options/border-radius";
import LayoutWidth from "%/dynamic-component-editor/options/layout-width";
import LayoutHeight from "%/dynamic-component-editor/options/layout-height";
import TextOptions from "%/dynamic-component-editor/bundles/text-options";
import LinkType from "%/dynamic-component-editor/options/link-type";
import {
  TextWithoutBrandingElementMixin,
} from "%/dynamic-component-editor/standard-elements/text-element/text-without-branding-element-mixin";
import EffectsOptions from "%/dynamic-component-editor/bundles/effects-options";
import AnimationEffectsOptions from "%/dynamic-component-editor/bundles/animation-effects-options";
import BackgroundOptions from "%/dynamic-component-editor/bundles/background-options";
import {
  SharedButtonComputedStylesMixin,
} from "%/dynamic-component-editor/standard-elements/button-element/shared-button-computed-styles-mixin";
import ButtonBranding from "%/dynamic-component-editor/classes/branding/button-branding";
import ButtonBorderOptions from "%/dynamic-component-editor/bundles/button-border-options";
import ButtonDisabled from "%/dynamic-component-editor/options/button-disabled";

export const ButtonElementMixin = {
  elementPanelSettings: {
    displayIcon: "message",
    elementType: "element",
  },
  brandingType: ButtonBranding,
  mixins: [TextWithoutBrandingElementMixin, DynamicElementMixin, SharedButtonComputedStylesMixin],
  props: {
    handleCustomClick: {
      type: Function,
      required: false,
      default: null,
    },
  },
  optionsOrder: [
    "button",
    "click-action",
  ],
  options: [
    ButtonDisabled,
  ],
  optionBundles: [
    AnimationEffectsOptions,
    new EffectsOptions({}, {
      "text-shadow": true,
    }),
    PositioningOptions,
    new LayoutWidthHeightOptions({
      "default.layout-width": "hug",
      "default.layout-height": "hug",
    }),
    new AppearanceOptions({
      "default.border-radius": "large",
    }, {
      "border-radius": false,
    }),
    new ButtonOptions({ "default.icon": "" }),
    ButtonBorderOptions,
    new SpacingOptions({
      "default.padding": {
        "top": null,
        "left": null,
        "bottom": null,
        "right": null,
      },
    }),
    new BasicTextOptions({
      "default.font-color": {
        value: "light",
        source: "theme.font",
      },
    }),
    new TextOptions({
      "default.text-wrap": "nowrap",
    }),
    new BackgroundOptions({
      "default.background-color": {
        value: "unset",
        source: "theme.background",
      },
    }, {
      "background-image": true,
    }),
  ],
  data() {
    return {
      ButtonType,
      ButtonDisabled,
      ButtonSize,
      Icon,
      IconPosition,
      ButtonIconSize,
      TextAlignment,
      ButtonAction,
      BorderRadius,
      LayoutHeight,
      LayoutWidth,
      LinkType,
    };
  },
};
